import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;
